import { createTheme, responsiveFontSizes } from "@mui/material";
import GeomanistRegular from "./assets/Geomanist-Regular.woff2";

const mainTheme = responsiveFontSizes(
  createTheme({
    palette: {
      background: {
        default: "#000",
      },
      primary: {
        main: "#A97D58", // main text colour
      },
      secondary: {
        main: "#E3E3DC", // conversation panel, circle background colour
      },
    },
    typography: {
      fontFamily: ["GeomanistRegular"].join(","),
      button: {
        textTransform: "none",
      },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: `
          @font-face {
            font-family: 'GeomanistRegular';
            src: url(${GeomanistRegular}) format('woff2');
            font-weight: 400;
            font-style: normal;
          }
        `,
      },
    },
  }),
);

export default mainTheme;
